import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";

import type { DrillItem } from "../../model/Drill";
import { TOPIC_LABELS } from "../../model/TOPIC_LABELS";
import { ProgressDots } from "./ProgressDots";

const STEP = msg({ message: "Task {step} of {total}" });

type SeriesHeaderProps = { items: DrillItem[]; current: number };

// Шапка серии: тема задачи со ссылкой на разбор матча, номер задачи и точки серии.
export const SeriesHeader = ({ items, current }: SeriesHeaderProps) => {
  const { i18n, t } = useLingui();
  const item = items[current];
  return (
    <div className="flex flex-wrap items-end justify-between gap-3">
      <div className="flex flex-col gap-1">
        {item !== undefined && (
          <Link
            to="/matches/$matchId"
            params={{ matchId: item.match_id }}
            className="text-[13px] text-muted no-underline hover:text-foreground"
          >
            {i18n._(TOPIC_LABELS[item.spec.topic])}{" "}
            <span className="text-accent">
              · {t`from your match analysis`} <span aria-hidden="true">→</span>
            </span>
          </Link>
        )}
        <h1 className="font-display text-[32px] leading-tight">
          {i18n._({ ...STEP, values: { step: current + 1, total: items.length } })}
        </h1>
      </div>
      <ProgressDots items={items} current={current} />
    </div>
  );
};
